import axiosClient from './axiosClient';
import { IMapbackPlaybackQueryParams, IMapbackTrackingItem } from '~/utils/interface/mapback';

const TIMEZONE_SUFFIX_REGEX = /Z|[+-]\d{2}:?\d{2}$/i;
const TRACKTIME_BASE_REGEX = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}/;

const formatTrackTimeUtc = (value?: string | number | null): string | undefined => {
  const stringValue = typeof value === 'number' ? String(value) : value;
  if (typeof stringValue !== 'string' || !stringValue.trim()) return undefined;

  const rawValue = stringValue.trim();
  if (!TRACKTIME_BASE_REGEX.test(rawValue)) {
    console.warn('[mapbackApi] Unrecognized tracktime format, fallback normalization will be applied:', rawValue);
  }

  const normalized = rawValue.replace('T', ' ');
  const withoutTimezone = normalized.replace(TIMEZONE_SUFFIX_REGEX, '');
  const withoutMilliseconds = withoutTimezone.replace(/\.\d+$/, '');

  return withoutMilliseconds.length >= 19 ? withoutMilliseconds.slice(0, 19) : withoutMilliseconds;
};

const mapbackApi = {
  getPlayback(params: IMapbackPlaybackQueryParams) {
    return axiosClient.get<unknown>('/api/map/playback/new', {
      params: {
        person_id: params.person_id,
        time_start: params.time_start,
        time_end: params.time_end,
      },
    });
  },

  getMapTracking(username: string, tracktimeUtc?: string | number | null) {
    const formattedTracktimeUtc = formatTrackTimeUtc(tracktimeUtc);

    return axiosClient.get<IMapbackTrackingItem[]>('/api/map/tracking', {
      params: {
        username,
        ...(formattedTracktimeUtc !== undefined ? { tracktime_utc: formattedTracktimeUtc } : {}),
      },
    });
  },
};

export default mapbackApi;
